import React, { useState, useEffect } from "react";
import { Input, Form, Row, Col, Button, Space, message, Menu, Drawer, Layout,Card, Tooltip } from 'antd';
import { MenuOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import "../../../styles/login.css";
import constants from '../../../constants/constants';
import { useHistory } from "react-router";
import { fetchAdminApi, fetchApi } from "../../../services/api";
import Footers from "../../../footer";
import Book from './Book';
import PasswordSuggestion from "../PasswordSuggestion";
const ResetPassword = () => {
	const { Header } = Layout;
	const [form] = Form.useForm();
	const [mobileMenu, setMobileMenu] = useState(false);
	const showMobileMenu = () => {setMobileMenu(true);};
	const closeMobileMenu = () => {setMobileMenu(false);};
	const history = useHistory();
	const [userToken,setUserToken]=useState("");
	const [passwordStatus,setPasswordStatus]=useState("");
	const [loading,setLoading]=useState(false);
	const [displayValidationMessage,setValidationMessage]=useState("");
	const [apiWait,setApiWait]=useState(false);
	const [isTokenValid,setIstokenVaid]=useState(false);
	const [isAdmin,setIsAdmin]=useState(false);
	useEffect(() => {
		fetchUrlParameters();
	}, []);
	const fetchUrlParameters=()=>{
		let queryString = window.location.href;
		var token = queryString.substring(queryString.lastIndexOf('?') + 1);
		var tempValueHref=queryString.substring(queryString.lastIndexOf('/') + 1);
		setIsAdmin(tempValueHref.split('?')[0]==="password-reset"?true:false);
		setUserToken(token);
		checkActivationvalidity(token,tempValueHref.split('?')[0]==="password-reset"?true:false);
	};
	const checkActivationvalidity=(tokenValue,isAdminValue)=>{
		let payload=null;
		payload={
			token:tokenValue,
			type:isAdminValue===true?"admin":"student"
		};
		fetchApi(`/user/validate-token`, "post",payload).then((res) => {
			if (res && res.code ) {
				setValidationMessage(res.message);
				setApiWait(true);
				if(res.code===200){
					setIstokenVaid(true);
				}else{
					setIstokenVaid(false);
				}
			}else{
				setApiWait(true);
				setIstokenVaid(false);
			}
		});
	};
	const handleResetPassword=(values)=>{
		let payload = {};
		payload = { 
			password: values.newPassword,
			confirm_password:values.confirmPassword,
			token:userToken,
			type:isAdmin===true?"admin":"student",
		};
		setLoading(true);
		if(isAdmin===true){
			fetchAdminApi("/user/reset-password", "post", payload).then((res) => {
				setLoading(false);
				if (res && res.code && res.code === 200) {
					setLoading(false);
					message.success(res.message);
					history.push("/admin-login");
				} else {
					setLoading(false);
					message.error(res.message);
				}
			});
		}else{
			fetchApi("/user/reset-password", "post", payload).then((res) => {
				setLoading(false);
				if (res && res.code && res.code === 200) {
					setLoading(false);
					message.success(res.message);
					history.push("/");
				} else {
					setLoading(false);
					message.error(res.message);
				}
			});
		}
	};
	//Function to validate password to check if it has 1 special character, 1 Upper case, 1 number and should have 14 characters and space are not allowed at the beginning and end of the password.
	const handlePasswordValidation = (rule, value, callback) => {
		try {
			if (!value) {
				setPasswordStatus("error");
				return callback(new Error(constants.PasswordRegistration));
			}
			const passwordValidate =/^(?=.{14,}$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s])[^\s].*[^\s]$/;
			if (!passwordValidate.test(value)) {
				setPasswordStatus("error");
				return callback(new Error(constants.PasswordValidation));
			}
			setPasswordStatus("success");
			return callback();
		} catch (err) {
			return callback(err);
		}
	};
	const handlePasswordSuggestion = (newPassword) => {
		form.setFieldsValue({ newPassword });
	};
	return (
		<div>
			<Header className="header-light slp-header pl-4 pr-3">
				<div>
					{/* Login header start */}
					<div className="logo bookname mt-3">
						<Space>
							<div className="mobile-menu-div">
								<Button
									type="primary"
									shape="circle"
									icon={<MenuOutlined/>}
									onClick={showMobileMenu}
									className="menu-btn"
								/>
							</div>
							<h3 className="mb-0" onClick={() => {
								window.open(constants.SiteUrl);
							}}>
									An Advanced Review of Speech-Language Pathology, 6th Edition:
									Practice Examinations
							</h3>
						</Space>
					</div>
					<div className="pc-navbar">
						<Menu mode="horizontal">
							<Menu.Item key="author1" onClick={()=>{window.open(constants.SiteUrl+'/authors#celeste-roseberry-mckibbin', '_blank');}}>
									Celeste Roseberry-McKibbin, Ph.D.
							</Menu.Item>
							<Menu.Item key="author2" onClick={()=>{window.open(constants.SiteUrl+'/authors#mn-hegde', '_blank');}}>M. N. Hegde, Ph.D.</Menu.Item>
							<Menu.Item key="author3" onClick={()=>{window.open(constants.SiteUrl+'/authors#glen-tellis', '_blank');}}>Glen M. Tellis, Ph.D.</Menu.Item>
						</Menu>
					</div>
					{/* Mobile Menu Start */}
					<div className="mobile-menu-div">
						<Drawer
							title="PRAXIS - SLP Review"
							placement="left"
							className="mobile-menu"
							onClose={closeMobileMenu}
							visible={mobileMenu}
						>
							<Menu mode="inline">
								<Menu.Item key="author1">Glen M. Tellis, PhD</Menu.Item>
								<Menu.Item key="author2">M. N. Hegde, PhD</Menu.Item>
								<Menu.Item key="author3">
										Celeste Roseberry-McKibbin, PhD
								</Menu.Item>
							</Menu>
						</Drawer>
					</div>
					{/* Mobile Menu End */}
					{/* Login header end */}
				</div>
			</Header>
			<div className="login-content flex-vertical-middle">
				<Row gutter={[{
					xs: 8,
					sm: 24,
					md: 48,
					lg: 8,
					xl: 8
				}, 8]} className="login-px">
					<Book/>
					<Col lg={24} xl={14} className="w-100 flex-middle">
						{isAdmin===true?null:
							<div className="signup-link">
								<Space>
									{constants.SignUpRedirect}
									<Button type="link" className="pl-0" onClick={()=>{	history.push("/registration");}}>
										{constants.SignUpRedirectLink}
									</Button>
								</Space>
							</div>
						}
						{apiWait===true?
							<div className="ml-135">
								<br/>
								{!isTokenValid?
									<Card>
										<h1 className="purple-bg p-3">{constants.ResetPsd}</h1>
										<div className="min-width-700" dangerouslySetInnerHTML={{ __html: displayValidationMessage }}/>
									</Card>
									:
									<>
										<h1>{constants.ResetPsd}</h1>
										<Form form={form} layout="vertical" onFinish={handleResetPassword}>
											<div className="login-form">
												<Form.Item
													name="newPassword"
													label={
														<Space>
															<span>{constants.NewPsd}</span>
															<Tooltip title={constants.PsdTip}>
																<QuestionCircleOutlined/>
															</Tooltip>
															<PasswordSuggestion onPasswordSelect={handlePasswordSuggestion}/>
														</Space>
													}
													validateStatus={passwordStatus}
													rules={[
														{
															required: true,
															message: "",
														},
														{ validator: handlePasswordValidation },
													]}
													hasFeedback
												>
													<Input.Password className="login-input" placeholder={constants.Password} autoFocus/>
												</Form.Item>
												<Form.Item
													name="confirmPassword"
													label={constants.ConfirmNewPsd}
													dependencies={["newPassword"]}
													hasFeedback
													rules={[
														{
															required: true,
															message: "Confirm your password",
														},
														({ getFieldValue }) => ({
															validator(_, value) {
																if (!value || getFieldValue("newPassword") === value) {
																	return Promise.resolve();
																}
																return Promise.reject(
																	new Error(
																		"The two passwords that you entered do not match"
																	)
																);
															},
														}),
													]}
												>
													<Input.Password className="login-input" placeholder={constants.ConfirmNewPsd}/>
												</Form.Item>
											</div>
											<Space>
												<Form.Item>
													<Button shape="round" size="large" className="gold-btn" onClick={()=>{isAdmin===true?history.push("/admin-login"):history.push("/");}}>
														{constants.BackToLogin}
													</Button>
												</Form.Item>
												<Form.Item>
													<Button shape="round" size="large" className="gold-btn" htmlType="submit" loading={loading}>
														{constants.ChangePsd}
													</Button>
												</Form.Item>
											</Space>
										</Form>
									</>
								}
							</div>
							:null}
					</Col>
				</Row>
			</div>
			<Footers/>
		</div>
	);
};
export default ResetPassword;
